





import { computed, defineComponent, toRefs } from '@vue/composition-api';
import FileInfo from '@/renderer/components/drawer/Detail/FileInfo.vue';
import { SMH } from '@/renderer/scripts/smh';
export default defineComponent({
  name: 'Detail',
  components: {
    FileInfo,
  },
  props: {
    params: {
      required: true,
      type: Object as () => Drawer.DetailParams<SMH.getDirectoryOrFileInfoData>,
    },
  },
  setup(props, context) {
    // 解构 props
    const { params } = toRefs(props);
    const spaceId = computed(() => params.value.spaceId);
    const isHistoryVersion = computed(() => params.value.isHistoryVersion);
    const baseFileInfo = computed(() => params.value.selectedItem);
    return {
      baseFileInfo,
      spaceId,
      isHistoryVersion,
    };
  },
});
